/**
 * ConversationFilterSelects — the kind filter for the Toolbar right slot (demo /tables/data-tables header selects).
 */
import { FilterSelect } from '../../../components/ui/FilterSelect.js';
import { KIND_OPTIONS } from './conversation-labels.js';

interface ConversationFilterSelectsProps {
  kind: string;
  onKindChange: (value: string) => void;
}

export function ConversationFilterSelects({ kind, onKindChange }: ConversationFilterSelectsProps) {
  return <FilterSelect label="Type" anyLabel="All types" value={kind} options={KIND_OPTIONS} onChange={onKindChange} />;
}
